import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import "./ProgressPills.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_fc357040 _7abf1313 _pub-7abf1313 _pub-a97d53f3",
    "ref": ref,
  }, 
    props["children"]
  )
}));
export default $$Default;

var ProgressPill = React.memo(React.forwardRef(function ProgressPill(props, ref) {
  return React.createElement("div", {
    "className": "_123b116c _7abf1313 _pub-7abf1313 _pub-a97d53f3" + (props["active"] ? " " + "_7abf1313_active _pub-7abf1313_active _pub-a97d53f3_active active" : ""),
    "ref": ref,
  }, null)
}));
export { ProgressPill };


